import React, { ComponentPropsWithRef, forwardRef } from 'react'
import cn from 'classnames'
import styled from 'styled-components'
import { FieldValues, UseFormRegister } from 'react-hook-form'

import { ArrowIcon } from '../icons/arrow-icon'
import { theme } from '../../lib/theme'

import InputWrapper from './InputWrapper'

const SSelect = styled.select`
    background-color: unset;
    border: 1px solid ${({ theme }) => theme.input.borderColor};
    padding: 10px 40px 10px 15px;
    font-size: 16px;
    line-height: 1.5;
    font-weight: var(--font-weight-light);
    min-height: calc(1.5em + 22px);
    width: 100%;
    position: relative;
    appearance: none;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:disabled {
        cursor: default;
        border-color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
        color: ${({ theme }) => theme.brandColors.CA_Mid_Gray};

        & ~ label {
            color: ${({ theme }) => theme.brandColors.CA_Light_Gray};
        }
    }

    &:not(:placeholder-shown),
    &:focus {
        & ~ label {
            font-size: 12px;
            top: -10px;
            background-color: white;
            border-radius: 2px;
        }
    }
    &.default-select {
        background-color: ${({ theme }) => theme.brandColors.CA_White};
        border: 1px solid ${({ theme }) => theme.input.borderColor};
        border-radius: 4px;
        font-size: 14px;
        &:disabled {
            background-color: #eeeeee;
            color: ${({ theme }) => theme.brandColors.CA_Dark_Gray};
            border-color: #cccccc;
        }
    }
    &.read-only {
        border: none;
        background-color: #fff;
        font-weight: var(--font-weight-bold);
        min-height: auto;
        padding: 5px 3px;
        color: ${({ theme }) => theme.brandColors.CA_Black};
    }
`

const SArrowIcon = styled(ArrowIcon)<{ flipped: boolean }>`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 15px;
    margin: auto 0;
    pointer-events: none;
    transition: transform 0.2s ease-in;
    transform: rotate(180deg);
    &.read-only {
        display: none;
    }
`

const SOption = styled.option`
    background-color: ${({ theme }) => theme.brandColors.CA_Lightest_Gray};
    max-width: 30%;
`

interface IInputProps extends ComponentPropsWithRef<'select'> {
    labelText?: string
    subtitle?: string
    unit?: string
    error?: string
    options: { key: string | number; value: string | null }[] | undefined
    readOnly?: boolean
    enableDefaultOption?: boolean
}

const Select = forwardRef<HTMLSelectElement, IInputProps & ReturnType<UseFormRegister<FieldValues>>>(
    ({ id, enableDefaultOption, labelText, readOnly, subtitle, options, error, unit, ...rest }: IInputProps, ref) => {
        return (
            <InputWrapper id={id} labelText={labelText} unit={unit} error={error} subtitle={subtitle}>
                <SSelect
                    id={id}
                    title={id}
                    placeholder=" "
                    {...rest}
                    ref={ref}
                    className={cn({
                        'read-only': readOnly,
                    })}
                >
                    {enableDefaultOption && <SOption label=" " value={undefined} />}
                    {options &&
                        options.map((nextOption, index) => {
                            return (
                                <SOption key={`option-${index}`} value={nextOption.key}>
                                    {nextOption.value}
                                </SOption>
                            )
                        })}
                </SSelect>

                <SArrowIcon
                    flipped={true}
                    color={theme.brandColors.CA_Black}
                    width={15}
                    height={6}
                    className={cn({
                        'read-only': readOnly,
                    })}
                />
            </InputWrapper>
        )
    }
)
export default Select
